import React from 'react';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import { Content, Header } from './modules';
import './Container.scss';

interface IContainerProps extends IChildrenProp, IDiv {
  disable?: boolean;
}

const Container = ({
  children,
  disable,
  className = '',
  ...props
}: IContainerProps) => {
  return (
    <div
      {...props}
      className={`container ${disable ? 'disable' : ''} ${className}`}>
      {children}
    </div>
  );
};

Container.Content = Content;
Container.Header = Header;

export default Container;
